<template>
    <div class="submit-input" @keydown="clickSubmitOnCtrlEnter">
        <b-form-fieldset class="mb-0">
            <b-input-group>
                <input
                    type="text"
                    class="form-control"
                    :disabled="disabled"
                    :placeholder="placeholder"
                    v-model="name"
                    ref="nameInput"
                />
                <b-button-group>
                    <b-button variant="danger" v-if="!hideDeleteBtn" @click="cancel">
                        <font-awesome-icon icon="fa-solid fa-xmark" />
                    </b-button>
                    <submit-button
                        ref="submitButton"
                        :confirm="confirm"
                        :submit="submit"
                        @after-error="afterError"
                        @after-success="afterSuccess"
                    >
                        <slot name="submit">
                            <font-awesome-icon icon="fa-solid fa-check" />
                        </slot>
                    </submit-button>
                </b-button-group>
            </b-input-group>
        </b-form-fieldset>
    </div>
</template>

<script>
import * as utils from '@/utils';

import Loader from './Loader';
import SubmitButton from './SubmitButton';

export default {
    name: 'submit-input',

    props: {
        placeholder: {
            type: String,
            default: undefined,
        },
        noAutoFocus: {
            type: Boolean,
            default: false,
        },
        confirm: {
            type: String,
            default: '',
        },
        hideDeleteBtn: {
            type: Boolean,
            default: false,
        },
        defaultValue: {
            type: String,
        },
        validationRegex: {
            type: RegExp,
            default: () => /./,
        },
        validationMessage: {
            type: String,
            default: 'Please give a name',
        },
    },

    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    data() {
        return {
            name: '',
            disabled: false,
        };
    },

    components: {
        SubmitButton,
        Loader,
    },

    computed: {
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        clickSubmitOnCtrlEnter() {
            return utils.ctrlOrCmd('Enter', () => {
                this.$withRef('submitButton', el => {
                    el.onClick();
                });
            });
        },
    },

    methods: {
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        submit() {
            if (this.name == null || !this.validationRegex.test(this.name)) {
                throw new Error(this.validationMessage);
            }

            this.disabled = true;

            return new Promise((resolve, reject) => {
                this.$emit('create', this.name, resolve, reject);
            });
        },

        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        afterError() {
            this.disabled = false;
        },

        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        afterSuccess(data) {
            this.name = '';
            this.disabled = false;
            this.$emit('after-submit', data);
        },

        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        cancel() {
            this.$emit('cancel');
        },

        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        async focusInput() {
            const input = await this.$waitForRef('nameInput');
            if (input != null) {
                input.focus();
            }
        },
    },

    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    mounted() {
        if (!this.noAutoFocus) {
            this.focusInput();
            this.name = this.defaultValue;
        }
    },
};
</script>

<style lang="less">
.submit-input .btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    height: 100%;
}
</style>
